import script from "./ModalReuse2.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalReuse2.vue?vue&type=script&setup=true&lang=js"

import "./ModalReuse2.vue?vue&type=style&index=0&id=45df0a1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45df0a1c"]])

export default __exports__